import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Consumer } from '../../../../models/consumer-model';
@Component({
    standalone: false,
    selector: 'por-lists',
    templateUrl: './lists.component.html',
    styleUrls: ['./lists.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConsumersListsComponent {
    @Input() consumers: Consumer[] | null = [];
    @Input() noMoreRecord = false;
    @Output() readonly loadMore = new EventEmitter();
    @Output() readonly generateLink = new EventEmitter();
    @Output() readonly viewContacts: EventEmitter<Consumer> = new EventEmitter<Consumer>();

    generateQuickLink(id: string) {
        this.generateLink.emit(id);
    }

    getViewContacts(consumer: Consumer) {
        this.viewContacts.emit(consumer);
    }
}
